<template>
  <b-modal title="Edição de Serviço" v-model="show" size="xl">
    <!-- :::::::::::::::::::::::::::: FORMULARIO DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <b-container fluid class="p-0 m-0">
      <b-row class="m-2">
        <b-col cols="12">
          <b-form-group label-cols-sm="1" label="Descrição:" label-align-sm="center">
            <b-form-textarea v-model="servico.descricao" rows="2"></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-cols-sm="2" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="servico.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-checkbox v-model="servico.concluido" name="check-button" switch class="pt-2">
            Serviço Concluído <b>(Checked: {{ servico.concluido }})</b>
          </b-form-checkbox>
        </b-col>
        <b-col cols="2">
          <b-button variant="outline-light" @click="salvar()">Salvar</b-button>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Servico from "@/models/Servico";
import Notificacao from "@/models/Notificacao";

export default {
  name: "ServicoEditModal",

  data() {
    return {
      show: false,
      servico: new Servico(0, "", new Date(), false, false),
    };
  },

  methods: {
    salvar() {
      if (this.servico.id != 0) {
        this.equipamentoStore.ALTERAR_SERVICO(this.servico).then(() => {
          this.store.NOTIFICAR(new Notificacao("Serviço salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
          this.show = !this.show;
        });
      } else {
        this.equipamentoStore.CADASTRAR_SERVICO(this.servico).then(() => {
          this.store.NOTIFICAR(new Notificacao("Serviço salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
          this.show = !this.show;
        });
      }
    },

    call(servico) {
      this.show = !this.show;
      this.servico = servico;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getServicos } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getServicos,
    };
  },
};
</script>

<style lang="scss" scoped></style>
